import { AbpMultiTenancyService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
    ApplicationInfoDto,
    BaseUserDto,
    GetCurrentLoginInformationsOutput,
    SessionServiceProxy,
    TenantLoginInfoDto,
    CompanyBaseDto,
} from '@shared/service-proxies/service-proxies';

@Injectable()
export class AppSessionService {
    constructor(private _sessionService: SessionServiceProxy, private _abpMultiTenancyService: AbpMultiTenancyService) {}

    private _user: BaseUserDto;
    private _company: CompanyBaseDto;

    get user(): BaseUserDto {
        return this._user;
    }

    set user(user: BaseUserDto) {
        this._user = user;
    }

    get company(): CompanyBaseDto{
        return this._company;
    }

    set company(company: CompanyBaseDto) {
        this._company = company;
    }

    private _tenant: TenantLoginInfoDto;

    get tenant(): TenantLoginInfoDto {
        return this._tenant;
    }

    private _application: ApplicationInfoDto;

    get application(): ApplicationInfoDto {
        return this._application;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    get tenantId(): number {
        return this.tenant ? this.tenant.id : null;
    }

    getShowCompanyName(): string {
        const companyName = this._company?.businessName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return companyName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + companyName;
    }

    getShownLoginName(): string {
        const userName = this._user?.userName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return userName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + userName;
    }

    init(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            firstValueFrom(this._sessionService.getCurrentLoginInformations()).then(
                (result: GetCurrentLoginInformationsOutput) => {
                    this._application = result.application;
                    this._user = result.user;
                    this._tenant = result.tenant;
                    this._company = result.company;

                    resolve(true);
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    changeTenantIfNeeded(tenantId?: number): boolean {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }

        abp.multiTenancy.setTenantIdCookie(tenantId);
        location.reload();
        return true;
    }

    private isCurrentTenant(tenantId?: number) {
        if (!tenantId && this.tenant) {
            return false;
        } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }

        return true;
    }
}
